import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class Fied extends BaseAPIModel {
    fields() {
        return {
            name: {},
            weez_id: { primaryKey: true, readOnly: true }
        };
    }

    get translated_label() {
        return this.get_translated_label(this.object.language);
    }

    get_translated_label(language) {
        return this.object.is_standard && language ? this.object.translations['label'][language] || this.object.label : this.object.label;
    }

    static list(apiList, language) {
        return apiList.map(item => this.fromJSON(item, language));
    }

    static fromJSON(item, language) {
        item.language = language ? language.toLowerCase() : null;
        const item_instance = new this(item);
        return item_instance;
    }

    static listUrl() {
        throw new ArgumentError(`[Model][Field][getAll] Need to implement some static methods before`);
    }
}
